import { useTranslations } from 'next-intl';
import Link from 'next-intl/link';
import { useLocaleRoutes } from '../utils/useLocaleRoutes';

export default function Disclaimer() {
  const t = useTranslations('navigation');
  const path = useLocaleRoutes();
  return (
    <>
      <p className='italic'>{t('disclaimer')}</p>
      <div>
        <Link href={`/${path('terms')}`} className='underline'>
          {t('terms')}
        </Link>
      </div>
    </>
  );
}
